import { netsparkAxios } from 'core/services/HTTPService';
import { IEngagementsTotalItem } from 'pages/Dashboard/Dashboard.models';
import { getEngagementsTotalOrdersTechnicalOverlayUrl } from 'pages/Dashboard/api/apiUrls';
// eslint-disable-next-line no-unused-vars
import { TPeriod } from 'shared/CustomRangePicker/CustomRangePicker.models';

export const getEngagementsOrdersTOTotal = (
  signal: AbortSignal, params: TPeriod,
) => netsparkAxios
  .get<IEngagementsTotalItem[]>(getEngagementsTotalOrdersTechnicalOverlayUrl, { signal, params });
